const translations = {
  'filters.levels': 'Niveles',
  'filters.selectLevel': 'Selección de {{level}}',
  'filters.destination': 'Destino',
  'filters.selectDestinations': 'Selección de destinos',
  'filters.selectPlaces': 'Selección de lugares'
}

export default translations
